import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/services/auth";
import App from "./app";
//@ts-expect-error: CSS import
import "./index.css"; // Tailwind directives and base styles

declare global {
  interface Window {
    __addinDiag?: {
      ready: boolean;
      errors: Array<{ kind: string; message: string; source?: string; line?: number }>;
      timeoutId: number | null;
      markReady: () => void;
    };
  }
}

// MSAL and the React root are created lazily inside Office.onReady so that
// any failure (e.g. localStorage unavailable in a sandboxed shared-mailbox
// iframe) bubbles up to the boot watchdog in taskpane.template.html instead
// of silently killing module-load before Office.onReady is ever registered.
Office.onReady(() => {
  const container = document.getElementById("root");
  if (!container) {
    console.error("Root element not found for React app.");
    return;
  }

  const msalInstance = new PublicClientApplication(msalConfig);
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );

  window.__addinDiag?.markReady();
});
